export default "__VITE_ASSET__BlX2qfOc__"